import { NavLink, useNavigate } from "react-router-dom"
import { ActionButton } from "./ActionButton"
import { useWebRoute } from "../../components-system/routing/use-routing.hook";
import { findPropInTree } from "../../components-fabric/_defaults/buttons/process-button";
export const NavigationButtonInner = (props: any) => {
  const {to, ...rest} = props;
  return <NavLink
  key={to}
  relative={"path"}
  to={to}> <ActionButton {...rest} /></NavLink>
}

export const NavigationButton = (props: any) => {
  const payload = findPropInTree('payload', props);
  const routeTo = props.to??payload?.path??"";
  const data =props.data??payload?.data??{};
  const to = useWebRoute(routeTo, data);
  return <NavigationButtonInner to={to} {...props} />
}

